<div class="navigation-control-buttons">
  <button class="nav-btn btn" title="{{ 'navigationControls.back' | translate }}"
          (click)="onBackClicked()">
    <svg-icon icon="arrow-left"></svg-icon>
  </button>

  <button class="nav-btn btn" title="{{ 'navigationControls.forward' | translate }}"
          (click)="onForwardClicked()">
    <svg-icon icon="arrow-right"></svg-icon>
  </button>

  <button class="nav-btn btn" title="{{ 'navigationControls.reload' | translate }}"
          (click)="onReloadClicked()">
    <svg-icon icon="refresh"></svg-icon>
  </button>
</div>
